const ROLE_ADMIN = 'admin';
const ROLE_POWER_ADMIN = 'power admin';
const ROLE_GLOBAL_ADMIN = 'global admin';

const PRIVILEGED_EDITOR_ACCESS_ROLES = Object.freeze([
  ROLE_POWER_ADMIN,
  ROLE_GLOBAL_ADMIN,
]);

export {
  ROLE_ADMIN,
  ROLE_POWER_ADMIN,
  ROLE_GLOBAL_ADMIN,
  PRIVILEGED_EDITOR_ACCESS_ROLES,
};
